import { baseURL } from "../../api/dataFetcher";
import { toPersianDigits } from "../../utils/exhibitionUtils";

export default function StoreDetails({ store, onClose }) {

  if (!store) return null;
  return (
    <div
      className="modal"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
        zIndex: 50000,
      }}
    >
      <div
        className="exhibition-card"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: 480,
          width: "100%",
          maxHeight: "70vh",
          overflow: "auto",
        }}
      >
        <div
          className="exhibition-row storeDetail"
          style={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 className="exhibition-title" style={{ fontSize: 20, margin: 0 }}>
            جزئیات غرفه {toPersianDigits(store.store_id_number)}
          </h2>
          <button
            className="exhibition-btn-small"
            onClick={onClose}
            style={{
              background: "var(--site-theme-dark)",
              color: "#fff",
            }}
          >
            ×
          </button>
        </div>
        <div className="exhibition-stack" style={{ marginTop: 12 }}>
          <div className="exhibition-card" style={{ padding: 12 }}>
            <div className="exhibition-stack">
              <div
                className="exhibition-row alignContentCenter"
                style={{ justifyContent: "space-between" }}
              >
                <div style={{ fontWeight: "bold" }}>شماره غرفه</div>
                <div style={{ color: "var(--site-theme-dark)" }}>
                  {toPersianDigits(store.store_id_number)}
                </div>
              </div>
              <img
                alt={store.store_name}
                src={
                  store?.cover
                    ? baseURL + store?.cover
                    : process.env.PUBLIC_URL + "/img/v1.png"
                }
                style={{
                  width: "100%",
                  objectFit: "cover",
                  borderRadius: 8,
                }}
              />
              {store.store_name && (
                <div
                  className="exhibition-row alignContentCenter"
                  style={{ justifyContent: "space-between" }}
                >
                  <div style={{ fontWeight: "bold" }}>نام غرفه</div>
                  <div style={{ color: "var(--site-theme-dark)" }}>
                    {store.store_name}
                  </div>
                </div>
              )}
              {/* {store.phone_number && (
                <div
                  className="exhibition-row"
                  style={{ justifyContent: "space-between" }}
                >
                  <div>شماره تماس</div>
                  <div style={{ color: "var(--site-theme-dark)" }}>
                    {toPersianDigits(store.phone_number)}
                  </div>
                </div>
              )} */}
            </div>
          </div>

          {store.description && (
            <div className="exhibition-card" style={{ padding: 12 }}>
              <div
                className="exhibition-title"
                style={{ fontSize: 16, fontWeight: "bold" }}
              >
                توضیحات
              </div>
              <p
                style={{
                  marginTop: 8,
                  whiteSpace: "pre-line",
                  textAlign: "justify",
                  lineHeight: "22px",
                }}
              >
                {store.description}
              </p>
            </div>
          )}

          {store.products && (
            <div className="exhibition-card" style={{ padding: 12 }}>
              <div
                className="exhibition-title"
                style={{ fontSize: 16, fontWeight: "bold" }}
              >
                محصولات
              </div>
              <div
                className="exhibition-stack"
                style={{
                  marginTop: 8,
                  textAlign: "justify",
                  whiteSpace: "pre-line",
                }}
              >
                {store.products}
              </div>
            </div>
          )}

          {store.site_address && (
            <div className="exhibition-card" style={{ padding: 12 }}>
              <div
                className="exhibition-title"
                style={{ fontSize: 16, fontWeight: "bold" }}
              >
                آدرس سایت
              </div>
              <a
                href={store.site_address}
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "var(--site-theme-dark)",
                  display: "flex",
                }}
              >
                {store.site_address}
              </a>
            </div>
          )}

          {/* {store.socialMedia?.length > 0 && (
            <div className="exhibition-card" style={{ padding: 12 }}>
              <div className="exhibition-title" style={{ fontSize: 16 }}>
                شبکه های اجتماعی
              </div>
              <div className="exhibition-stack" style={{ marginTop: 8 }}>
                {store.socialMedia.map((sm, idx) => (
                  <a
                    key={idx}
                    href={sm.url}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "var(--site-theme-dark)",
                      textAlign: "right",
                    }}
                  >
                    {sm.platform}
                  </a>
                ))}
              </div>
            </div>
          )} */}

          {store.otherLinks && (
            <div className="exhibition-card" style={{ padding: 12 }}>
              <div
                className="exhibition-title"
                style={{ fontSize: 16, fontWeight: "bold" }}
              >
                کانال وقف نما
              </div>
              <div className="exhibition-stack" style={{ marginTop: 8 }}>
                {store.otherLinks.map((ol, idx) => (
                  <a
                    key={idx}
                    href={store.vaghfnama_channel_address}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "var(--site-theme-dark)",
                      textAlign: "center",
                    }}
                  >
                    {store.vaghfnama_channel_address}
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
